export function CommonLayerLabels(state = [], action) {
  switch (action.type) {
    case 'SET_LAYER_LABELS': {
      return action.payload
    }
    default:
      return state
  }
}
